import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useDropdownFilter = ({
    dataList,
    searchInput,
    inputRef,
    isDynamic,
    defaultItem = { id: '1', name: 'Not Applicable' },
}) => {
    const location = useLocation();
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const cleanedSearchInput = searchInput?.toLowerCase()?.replace(/\s+/g, '') || '';

        const filteredSuggestions = dataList?.filter((item) => {
            // Create a searchable string from all relevant fields
            const searchableFields = [
                item?.name,
                item?.ledger_name,
                item?.symbol,
                item?.opening_balance?.toString(), // Convert number to string
                item?.mobile_no?.toString(), // Convert number to string
                item?.aadhaar_no?.toString(), // Convert number to string
                item?.under_name,
                item?.city
            ].filter(Boolean); // Remove null/undefined values

            const searchableText = searchableFields.join(' ').toLowerCase().replace(/\s+/g, '');

            return searchableText.includes(cleanedSearchInput);
        });

        const selectionStart = isDynamic ? inputRef?.selectionStart : inputRef?.current?.selectionStart;
        const selectionEnd = isDynamic ? inputRef?.selectionEnd : inputRef?.current?.selectionEnd;

        const isFullSelection = searchInput !== '' && selectionStart === 0 && selectionEnd === searchInput?.length;

        const isExactMatch = dataList?.some((item) => {
            const itemName = (item?.name || item?.symbol || item?.ledger_name)?.toLowerCase()?.replace(/\s+/g, '') || '';
            return itemName === cleanedSearchInput;
        });

        const shouldUseFilteredData =
            searchInput !== '' &&
            selectionStart > 0 &&
            !isFullSelection &&
            !isExactMatch;

        setFilteredData(shouldUseFilteredData ? filteredSuggestions : dataList);

    }, [dataList, searchInput, inputRef?.current?.selectionStart, inputRef?.current?.selectionEnd]);

    return { filteredData };
};
